/**
 * @generated SignedSource<<82f30fab76508dad155e7dded6292fa6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdBlockListItem_PerformanceSummarizedMetaAd$data = {
  readonly amountSpent: any | null;
  readonly brandName: string | null;
  readonly externalId: string | null;
  readonly id: string;
  readonly name: string | null;
  readonly primaryText: string | null;
  readonly rate: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"FullAdPreview_PerformanceSummarizedMetaAd">;
  readonly " $fragmentType": "AdBlockListItem_PerformanceSummarizedMetaAd";
};
export type AdBlockListItem_PerformanceSummarizedMetaAd$key = {
  readonly " $data"?: AdBlockListItem_PerformanceSummarizedMetaAd$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdBlockListItem_PerformanceSummarizedMetaAd">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdBlockListItem_PerformanceSummarizedMetaAd",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brandName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountSpent",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FullAdPreview_PerformanceSummarizedMetaAd"
    }
  ],
  "type": "PerformanceSummarizedMetaAd",
  "abstractKey": null
};

(node as any).hash = "665a63adf5b616f767359412afb7fb4c";

export default node;
